<template>
  <el-row>
    <el-col :span="16">
      <el-form :model="node.content">
        <el-alert
          title="WhatsApp contact card"
          type="info"
          :closable="false"
          show-icon
          style="margin-bottom: 12px"
        >
          <div style="line-height: 1.6">
            Minimum format: a display name in <code>name.formatted_name</code> and at least one
            phone entry. <code>name.first_name</code> is optional.
          </div>
          <pre class="contact-example">{{ formatExamples }}</pre>
        </el-alert>
        <transition-group name="section-list">
          <div v-for="(contact, index) in node.content.options.contacts" :key="index + 1">
            <WhatsAppContactItem @deleteContact="deleteContact" :contact="contact" :index="index" />
          </div>
        </transition-group>

        <div style="margin: 10px 0">
          <el-button type="primary" @click="addContact">Add Contact</el-button>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>
<script>
import WhatsAppContactItem from "@/components/WhatsAppContactItem";

export default {
  name: "WhatsAppContactMessage",
  components: {
    WhatsAppContactItem,
  },
  props: ["node", "editable"],
  data() {
    return {};
  },
  computed: {
    formatExamples() {
      return `Minimal example:
{
  "name": { "formatted_name": "Jane Doe" },
  "phones": [
    { "phone": "+16505551234", "type": "CELL" }
  ]
}

Fuller example:
{
  "name": {
    "formatted_name": "Jane Doe",
    "first_name": "Jane",
    "last_name": "Doe"
  },
  "phones": [
    {
      "phone": "+16505551234",
      "type": "CELL",
      "wa_id": "16505551234"
    }
  ]
}`;
    },
  },
  created() {
    if (!Array.isArray(this.node.content?.options?.contacts)) {
      this.$set(this.node.content.options, "contacts", []);
    }
    this.node.content.options.contacts = this.node.content.options.contacts.map((contact) =>
      this.normalizeContact(contact)
    );
  },
  methods: {
    createEmptyContact() {
      return {
        addresses: [],
        birthday: "",
        emails: [],
        name: {
          formatted_name: "",
          first_name: "",
        },
        org: {},
        phones: [
          {
            phone: "",
            type: "CELL",
            wa_id: "",
          },
        ],
        urls: [],
      };
    },
    normalizeContact(contact = {}) {
      const defaults = this.createEmptyContact();
      return {
        ...defaults,
        ...contact,
        name: {
          ...defaults.name,
          ...(contact.name || {}),
        },
        org: {
          ...defaults.org,
          ...(contact.org || {}),
        },
        phones:
          Array.isArray(contact.phones) && contact.phones.length > 0
            ? contact.phones
            : defaults.phones,
        addresses: Array.isArray(contact.addresses) ? contact.addresses : [],
        emails: Array.isArray(contact.emails) ? contact.emails : [],
        urls: Array.isArray(contact.urls) ? contact.urls : [],
      };
    },
    addContact() {
      this.node.content.options.contacts.push(this.createEmptyContact());
    },
    deleteContact(index) {
      this.$confirm("Are you sure you want to delete this contact? ", "Confirmation", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        cancelButtonClass: "section-delete-btn-cancel",
        confirmButtonClass: "section-delete-btn-confirm",
        type: "warning",
      }).then(() => {
        this.node.content.options.contacts.splice(index, 1);
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/scss/colors.scss";

.interactive-message-section {
  border: 1px solid $color-light;
  padding: 0px 25px;
  padding-top: 25px;
  padding-bottom: 15px;
  margin: 10px 0;
  border-radius: 5px;
  position: relative;
}

.section-delete-button {
  position: absolute;
  right: 6px;
  top: 6px;
  border: 0;
  padding: 0;
  background: #fff;
  font-size: 16px;
  color: #333;
}
.section-delete-button:hover {
  color: $color-danger;
}

.section-list-enter-active,
.section-list-leave-active {
  transition: all 0.5s ease;
}
.section-list-enter-from,
.section-list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.contact-example {
  margin: 12px 0 0;
  padding: 12px;
  border-radius: 4px;
  background: #f7f8fa;
  border: 1px solid $color-light;
  white-space: pre-wrap;
  font-size: 12px;
  line-height: 1.5;
}
</style>
